import { Main as RateChangeLogsTable } from '../tables/rate-change-logs/main';

function RateChangeLogs() {
  return <RateChangeLogsTable />;
}

export default RateChangeLogs;
